module.exports = __webpack_public_path__ + "img/image-thumb-9.1447f283.webp";